import { CloudIcon, MonitorIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Tooltip, TooltipPopup, TooltipTrigger } from "../ui/tooltip";
import type { ProjectEnvironmentKind } from "./projectGroupedSidebar.logic";

interface ProjectEnvironmentIconProps {
  readonly kind: ProjectEnvironmentKind;
  readonly label: string;
}

export function ProjectEnvironmentIcon({ kind, label }: ProjectEnvironmentIconProps) {
  let icon: ReactNode;
  if (kind === "mixed") {
    icon = (
      <span className="relative size-4" aria-hidden="true">
        <MonitorIcon className="absolute bottom-0 left-0 size-2.5" />
        <CloudIcon className="absolute right-0 top-0 size-2.5" />
      </span>
    );
  } else {
    const Icon = kind === "cloud" ? CloudIcon : MonitorIcon;
    icon = <Icon className="size-3" />;
  }

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <span
            aria-label={label}
            data-testid={`project-environment-icon-${kind}`}
            className="inline-flex size-5 shrink-0 items-center justify-center text-muted-foreground/65"
          >
            {icon}
          </span>
        }
      />
      <TooltipPopup side="top">{label}</TooltipPopup>
    </Tooltip>
  );
}
